module.exports = __webpack_public_path__ + "img/icon-74.e2edc636.png";